export default function Info() {
  return (
    <div
      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c9140dd"
      data-id="c9140dd"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <div
          className="elementor-element elementor-element-383aac9 elementor-widget elementor-widget-heading"
          data-id="383aac9"
          data-element_type="widget"
          data-widget_type="heading.default"
        >
          <div className="elementor-widget-container">
            <h2 className="elementor-heading-title elementor-size-default">
              IS Auditr
            </h2>
          </div>
        </div>

        <div
          className="elementor-element elementor-element-ba2ce09 elementor-mobile-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
          data-id="ba2ce09"
          data-element_type="widget"
          data-widget_type="icon-list.default"
        >
          <div className="elementor-widget-container">
            <ul className="elementor-icon-list-items">
              <li className="elementor-icon-list-item">
                <a href="mailto:hello@isauditr.com">
                  <span className="elementor-icon-list-text">
                    hello@isauditr.com
                  </span>
                </a>
              </li>

              <li className="elementor-icon-list-item">
                <a href="tel:212-440-1919">
                  <span className="elementor-icon-list-text">
                    +91 97188 35704
                  </span>
                </a>
              </li>

              {/* <li className="elementor-icon-list-item">
                        <span className="elementor-icon-list-text">
                          Sector - 68, Mohali, Punjab 160062
                        </span>
                      </li> */}

              <li className="elementor-icon-list-item">
                <span className="elementor-icon-list-text">
                  Mon-Sat 9am-6pm
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="elementor-element elementor-element-65718bc elementor-widget elementor-widget-heading"
          data-id="65718bc"
          data-element_type="widget"
          data-widget_type="heading.default"
        >
          <div className="elementor-widget-container">
            <h2 className="elementor-heading-title elementor-size-default">
              Join the team
            </h2>
          </div>
        </div>

        <div
          className="elementor-element elementor-element-d5fd255 elementor-mobile-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
          data-id="d5fd255"
          data-element_type="widget"
          data-widget_type="icon-list.default"
        >
          <div className="elementor-widget-container">
            <ul className="elementor-icon-list-items">
              <li className="elementor-icon-list-item">
                <a href="mailto:team@isauditr.com">
                  <span className="elementor-icon-list-text">
                    team@isauditr.com
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
